module.exports = __webpack_public_path__ + "res/4-img_more.664c1c6f4d66e2ab1088438beaab460c.png";